import { render } from "./ProveedorComponent.vue?vue&type=template&id=dd1b1968"
import script from "./ProveedorComponent.vue?vue&type=script&lang=js"
export * from "./ProveedorComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__